import { useContext, useEffect, useState } from 'react';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { FormCardLayout } from '@main/components';
import Button from '@mui/material/Button';
import { showMessage } from 'app/store/core/messageSlice';
import { useRequest } from '@main/hooks';
import { regexEmail, regexTitle } from 'src/app/utils/validations';
import { useSimpleAlert } from '@main/hooks/useSimpleAlert';
import { laravelInstall, laravelAdmin, laravelToken } from 'src/app/api/setup';
import { delayFunction } from 'src/app/utils/timer';
import { arraysContainSameValues } from 'src/app/utils/conversors';
import { Divider } from '@mui/material';
import { ProgressStep } from '../Components';
import { StepperContext } from '../Context/SetupContext';
import { checkpointsLaravel, getCompletedCheckpoints } from '../Checkpoints/checkpoints';

const pleskSchema = yup.object().shape({
  name: yup
    .string()
    .required('El nombre no puede quedar vacío')
    .min(3, 'El nombre debe contener al menos 3 letras')
    .matches(regexTitle, 'Solo letras y espacios entre nombres'),
  email: yup.string().matches(regexEmail, 'Debes ingresar un correo válido'),
  password: yup.string().min(6, 'la contrasena debe contener al menos 6 letras'),
});

const defaultValues = {
  name: 'Administrator BioMetrics',
  email: 'admin@bio-metrics.net',
  password: '123456',
};

export const Laravel = ({ onSuccess = () => {} }) => {
  const Dispatch = useDispatch();
  const openAlert = useSimpleAlert();
  const { addLogs, companyId, currentCheckpoint } = useContext(StepperContext);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [showPassword, setShowPassword] = useState(true);

  // -------- Obteniendo checkpoints
  const handleUpdateSteps = (incomingStep) => {
    const stepIsThere = completedSteps.includes(incomingStep);
    if (stepIsThere) return;
    setCompletedSteps((current) => [...current, incomingStep]);
  };

  useEffect(() => {
    if (currentCheckpoint === undefined || currentCheckpoint === null) return;
    const isThere = checkpointsLaravel.includes(currentCheckpoint);
    if (!isThere) return;
    console.log(currentCheckpoint);
    const checkpointsList = getCompletedCheckpoints(currentCheckpoint);
    if (checkpointsList !== undefined) {
      console.log(checkpointsList);
      setCompletedSteps(checkpointsList);
    }
  }, [currentCheckpoint]);

  useEffect(() => {
    console.log('completed steps', completedSteps);
    if (completedSteps === undefined) return;
    console.log('has changed completedSteps');
    const isStepsComplete = arraysContainSameValues(completedSteps, checkpointsLaravel);
    console.log('Esta completo? ', isStepsComplete);
    setIsCompleted(isStepsComplete);
  }, [completedSteps]);

  useEffect(() => {
    if (isCompleted === undefined) return;
    onSuccess(isCompleted);
  }, [isCompleted]);

  useEffect(() => {
    return () => {
      setCompletedSteps([]);
    };
  }, []);

  // -------- Definicion de requests
  const {
    makeRequest: tryLaravelInstall,
    isLoading: isLoadingLaravelInstall,
    status: statusLaravelInstall,
    logger: loggerLaravelInstall,
  } = useRequest(laravelInstall);

  const {
    makeRequest: tryLaravelAdmin,
    isLoading: isLoadingLaravelAdmin,
    status: statusLaravelAdmin,
    logger: loggerLaravelAdmin,
  } = useRequest(laravelAdmin);

  const {
    makeRequest: tryLaravelToken,
    isLoading: isLoadingLaravelToken,
    status: statusLaravelToken,
    logger: loggerLaravelToken,
  } = useRequest(laravelToken);

  // ------ Listeners de logs ------
  useEffect(() => {
    if (loggerLaravelInstall === undefined) return;
    addLogs(loggerLaravelInstall);
  }, [loggerLaravelInstall]);

  useEffect(() => {
    if (loggerLaravelAdmin === undefined) return;
    addLogs(loggerLaravelAdmin);
  }, [loggerLaravelAdmin]);

  useEffect(() => {
    if (loggerLaravelToken === undefined) return;
    addLogs(loggerLaravelToken);
  }, [loggerLaravelToken]);

  const tryStepsWizard = async (currentForm) => {
    if (companyId === undefined) {
      Dispatch(
        showMessage({
          message: 'No se encontro el ID de compania',
        })
      );
      return;
    }
    try {
      // ---- Instalacion de laravel
      const step17ok = await delayFunction(
        completedSteps.includes(checkpointsLaravel[0]),
        tryLaravelInstall,
        companyId
      );
      if (!step17ok) return;
      handleUpdateSteps(checkpointsLaravel[0]);
      console.log('Step okii');

      // ---- Generando Token
      const step19ok = await delayFunction(
        completedSteps.includes(checkpointsLaravel[1]),
        tryLaravelToken,
        companyId
      );
      if (!step19ok) return;
      handleUpdateSteps(checkpointsLaravel[1]);
      console.log('Step okii');

      // ---- Inicializacion de Manager
      const step18ok = await delayFunction(
        completedSteps.includes(checkpointsLaravel[2]),
        tryLaravelAdmin,
        companyId
      );
      if (!step18ok) return;
      handleUpdateSteps(checkpointsLaravel[2]);
      console.log('Step okii');
    } catch (error) {
      console.log(error);
    } finally {
      setDisableButton(false);
    }
  };

  const handleBypassStep = (stepName) => {
    if (typeof stepName !== 'string' || stepName === undefined) return;
    openAlert({
      title: 'Atencion',
      description: 'Esta seguro que desea omitir este paso?',
    }).then((userResponseOk) => {
      if (!userResponseOk) return;
      handleUpdateSteps(stepName);
      Dispatch(
        showMessage({
          message: `El paso ${stepName} ha sido omitido`,
        })
      );
    });
  };

  useEffect(() => {
    console.log(companyId);
  }, [companyId]);

  const handleShowPassword = () => {
    setShowPassword((current) => !current);
  };

  const handleManualRetry = (reqToRetry = () => new Promise(), ...args) => {
    reqToRetry(...args)
      .then((isOk) => {
        console.log(isOk);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <FormCardLayout.RowButton>
        <Button
          aria-label="Comenzar"
          onClick={tryStepsWizard}
          variant="contained"
          className="w-full md:w-auto"
          color="primary"
          disabled={disableButton || isCompleted}
        >
          Comenzar
        </Button>
      </FormCardLayout.RowButton>
      <FormCardLayout.FullColum>
        <Divider variant="middle" />
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <div className="px-32 flex flex-col w-full justify-start items-start">
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsLaravel[0])}
            status={
              completedSteps.includes(checkpointsLaravel[0]) ? 'SUCCESS' : statusLaravelInstall
            }
            isLoading={isLoadingLaravelInstall}
            stepName="Instalando laravel"
            disableOptions={completedSteps.includes(checkpointsLaravel[0])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsLaravel[1])}
            status={completedSteps.includes(checkpointsLaravel[1]) ? 'SUCCESS' : statusLaravelAdmin}
            isLoading={isLoadingLaravelAdmin}
            stepName="Inicializando Token"
            disableOptions={completedSteps.includes(checkpointsLaravel[1])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsLaravel[2])}
            status={completedSteps.includes(checkpointsLaravel[2]) ? 'SUCCESS' : statusLaravelToken}
            isLoading={isLoadingLaravelToken}
            stepName="Creando usuario de manager"
            disableOptions={completedSteps.includes(checkpointsLaravel[2])}
          />
        </div>
      </FormCardLayout.FullColum>
    </>
  );
};
